import React from 'react';
import { OptinPage } from './components/OptinPage';
export function App() {
  return <OptinPage data-id="element-0" />;
}